import { getPreviewTime } from 'components/b2c/Mp3KbpPlayer/Mp3KbpPlayer.utils';
import { SECONDS_TO_MS_RATIO } from 'services/helpers/formatTime';
import { Block } from 'shared-types/lyrics';

import { MENTION_SLIDE_END_TIME_IN_SECONDS } from '../MentionSlide/MentionSlide.utils';

// TODO: block start and end times are expressed in a very weird
// unit: 1 / 10 000 s... this value is written by the kbpToJsonParser:
// it should be refactored to milliseconds to avoid using this weird ratio
const SECONDS_TO_LYRICS_TIME_RATIO = 10000;
export const LYRICS_TIME_TO_MS_RATIO = 0.1;

export const findCurrentBlocksIndexes = (
  blocks: Block[],
  currentTimeInSeconds: number,
): number[] => {
  const currentTimeInLyricsUnit = currentTimeInSeconds * SECONDS_TO_LYRICS_TIME_RATIO;
  const currentBlocksIndexes = [];

  for (const [blockIndex, block] of blocks.entries()) {
    // blocks are ordered by start time, so we stop searching
    // when block startTime is greater than currentTime
    if (block.blockStart > currentTimeInLyricsUnit) break;

    if (isCurrentTimeInBlock(block, currentTimeInLyricsUnit)) {
      currentBlocksIndexes.push(blockIndex);
    }
  }

  return currentBlocksIndexes;
};

const isCurrentTimeInBlock = (block: Block, currentTimeInLyricsUnit: number): boolean =>
  block.blockStart <= currentTimeInLyricsUnit && currentTimeInLyricsUnit < block.blockEnd;

export const updateCurrentTime = (
  isPremium: boolean,
  videoElement: HTMLVideoElement,
  setCurrentTime: (currentTime: number) => void,
  updateCurrentBlockIndexes: (currentTime: number) => void,
) => {
  const currentTime = isPremium
    ? videoElement.currentTime
    : getPreviewTime(videoElement.currentTime);
  setCurrentTime(currentTime);
  updateCurrentBlockIndexes(currentTime);
};

export const shouldDisplayLyrics = (currentTimeInSongInMs: number) => {
  return currentTimeInSongInMs >= MENTION_SLIDE_END_TIME_IN_SECONDS * SECONDS_TO_MS_RATIO;
};
